export default __webpack_public_path__ + "static/4-3b4652402cd67430374da03f4c75d1b3.png";